import { Link } from "react-router-dom";
import { specials } from "@/mocks/media";

export default function SpecialShowcase() {
  return (
    <section className="mx-auto w-full px-4 md:px-6">
      <div className="mb-5 flex items-end justify-between gap-4">
        <div>
          <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            <i className="ri-bookmark-3-line text-accent-500"></i>
            主题专题推荐
          </h2>
          <p className="mt-1 text-sm text-foreground-500">
            编辑精选影视合集，按主题发现你的下一部心头好
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 md:gap-5 lg:grid-cols-3">
        {specials.map((special, i) => (
          <Link
            key={special.id}
            to={`/special/${special.id}`}
            className="group relative block overflow-hidden rounded-lg"
          >
            <div className="relative h-56 w-full overflow-hidden">
              <img
                src={special.cover}
                alt={special.title}
                title={`${special.title} 专题封面`}
                className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/40 to-transparent"></div>
            </div>
            <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
              <span
                className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-semibold ${
                  i === 1
                    ? "bg-accent-500 text-background-50"
                    : "bg-primary-500 text-background-50"
                }`}
              >
                <i className="ri-price-tag-3-line"></i>
                专题策划
              </span>
              <h3 className="mt-2 font-heading text-lg font-bold text-background-50">
                {special.title}
              </h3>
              <p className="mt-1 line-clamp-1 text-xs text-background-300">
                {special.subtitle}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}